import {UpdateSettingsSchema} from '@cypro/engine/mutators'
import {Settings} from '@cypro/engine/schema'

// `allowVialReuse` is edited as a labelled dropdown instead of a boolean switch.
export type SettingsFormSchema = Omit<UpdateSettingsSchema, 'allowVialReuse'> & {
  allowVialReuse: 'permitted' | 'not_permitted'
}

// `doctorRelease` defaults to true; when false the patient-arrival step is skipped
export function isPatientArrivalEnabled(settings: Settings | undefined): boolean {
  return settings?.doctorRelease !== false
}

export function getDefaultSettingsFormValues(setting: Settings | undefined): SettingsFormSchema {
  return {
    licence: setting?.licence ?? '',
    bsaFormula: setting?.bsaFormula,
    ibwFormula: setting?.ibwFormula,
    activeProtocolWarning: setting?.activeProtocolWarning,
    doctorRelease: setting?.doctorRelease,
    deliveryAutoRelease: setting?.deliveryAutoRelease,
    autIdemLogic: setting?.autIdemLogic,
    validationBypass: setting?.validationBypass,
    prescribeByTradeName: setting?.prescribeByTradeName,
    allowManualPatients: setting?.allowManualPatients ?? true,
    allowManualStock: setting?.allowManualStock ?? true,
    markAdministeredOnDispatch: setting?.markAdministeredOnDispatch,
    administrationMode: setting?.administrationMode,
    weightTolerance: setting?.weightTolerance,
    weightAutoConfirm: setting?.weightAutoConfirm ?? true,
    weightAutoConfirmDelayMs: setting?.weightAutoConfirmDelayMs ?? 2000,
    language: setting?.language,
    loginText: setting?.loginText ?? '',
    patientNameOrder: setting?.patientNameOrder,
    patientIdentifier: setting?.patientIdentifier,
    allowVialReuse: setting?.allowVialReuse ? 'permitted' : 'not_permitted',
    useVialSource: setting?.useVialSource,
    minimumSaveableVolume: setting?.minimumSaveableVolume ?? 10,
    dayZeroProtocol: setting?.dayZeroProtocol,
    useScales: setting?.useScales ?? true,
    recordScaleMemoryNumbers: setting?.recordScaleMemoryNumbers ?? true,
    skipSolventStockCheck: setting?.skipSolventStockCheck ?? false,
    showHospitalPatientId: setting?.showHospitalPatientId ?? true,
    sessionDurationMinutes: setting?.sessionDurationMinutes ?? 10080,
    // printouts
    prescribingDoctor: setting?.prescribingDoctor ?? true,
    hospitalNumber: setting?.hospitalNumber ?? true,
    customerName: setting?.customerName ?? true,
    wardNextToCustomerName: setting?.wardNextToCustomerName ?? false,
    manufacturer: setting?.manufacturer ?? true,
    tradeNameBeforeSubstance: setting?.tradeNameBeforeSubstance ?? false,
    concentration: setting?.concentration ?? true,
    actualQuantity: setting?.actualQuantity ?? true,
    preparedBy: setting?.preparedBy ?? true,
    pharmacyNameAndAddress: setting?.pharmacyNameAndAddress ?? true,
    additionalLabelBarcode: setting?.additionalLabelBarcode ?? false,
    labelVolume: setting?.labelVolume,
    labelSize: setting?.labelSize,
    bandTextCytotoxic: setting?.bandTextCytotoxic ?? '',
    bandTextNonCytotoxic: setting?.bandTextNonCytotoxic ?? '',
    labelCopies: setting?.labelCopies ?? 1,
    printReportAutomatically: setting?.printReportAutomatically ?? false,
    includeLabelCopy: setting?.includeLabelCopy ?? false,
    includeEndControlSignatures: setting?.includeEndControlSignatures ?? false,
    showScaleMemoryNumbers: setting?.showScaleMemoryNumbers ?? true,
    showProductCodeColumn: setting?.showProductCodeColumn ?? true,
    concentrationBasis: setting?.concentrationBasis,
    deliveryNoteCopies: setting?.deliveryNoteCopies ?? 3,
    releaseApprovalRequired: setting?.releaseApprovalRequired ?? true,
    signatureLinesOnPrintouts: setting?.signatureLinesOnPrintouts ?? true,
  }
}
